<script>
export default {
  name: 'InputComponent',
  props: {
    theme: {
      type: String,
      default: 'grey',
      required: false,
    },
  },
};
</script>
